// extracted by mini-css-extract-plugin
export default {"pos-center":"Loader_pos-center__L-pK4","loader":"Loader_loader__CKTiZ","spin":"Loader_spin__w+I5r","wrapper":"Loader_wrapper__Fwg3U"};